import axios from 'axios';
import _ from 'lodash';

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const GET_ATTRIBUTES = '/.netlify/functions/InvGetItemSerialAttributes';

const GetAssetAttributes = async (token: string, serialNo: string) => {

  const fetchData = async () => {
    try {
      const assetAttributes = await axios.post(
        GET_ATTRIBUTES,
        `<Parameters><SerialNo>${serialNo}</SerialNo></Parameters>`,
        {
          headers: {
            'Content-Type': 'application/xml',
            'X-Pronto-Token': token,
          }
        }
      );

      if( assetAttributes.status == 200) {
        let attributes = assetAttributes.data.InvGetItemSerialAttributesResponse.ItemSerialAttributes.ItemSerialAttribute

        if(attributes) {
          if(_.isArray(attributes)) {
            return attributes
          } else if (_.isObject(attributes)) {
            return [attributes];
          }
        } else {
          return [];
        }
      }
    } catch (err) {
      if(err.response.status == 401) {
        if(err.response.data == 'TokenExpired') {
          throw(TOKEN_EXPIRED)
        }
      } else if(err.response.status == 504) {
        throw(TIMEOUT);
      } else if(err.response.status == 500) {
        throw(INTERNAL_ERROR);
      }
    }
  };

  return await fetchData();
};

export default GetAssetAttributes;